import { useMediaQuery, useTheme } from '@material-ui/core'
import { Button } from '@resiliatech/birdsong'
import { useAppState } from 'Context/AppContext/AppContext'
import { analytics } from 'Modules/Analytics'
import { initiatives } from 'Modules/Analytics/trackActionInterface/Impact/Initiatives'

type CreateChartButtonProps = {
  objectiveId?: number
  objectiveTitle?: string
  goalId: number
  goalTitle: string
  onOpen: (isOpen: boolean) => void
}

export const CreateChartButton = ({
  objectiveId,
  objectiveTitle,
  goalId,
  goalTitle,
  onOpen,
}: CreateChartButtonProps) => {
  const appState = useAppState()
  const theme = useTheme()
  const isScreenLarge = useMediaQuery(theme.breakpoints.up('md'))

  const handleCreateChart = () => {
    onOpen(true)

    // Send analytics event
    const dispatchCreateChartClicked = analytics.trackActionCreator(
      initiatives.Goal_Create_Goal_Chart_Clicked
    )
    dispatchCreateChartClicked({
      reportedMetricGroupTitle: objectiveTitle,
      reportedMetricGroupId: objectiveId,
      reportedMetricId: goalId,
      reportedMetricTitle: goalTitle,
      role: appState.nonprofitOrgConfig.role,
      relationship: appState.nonprofitOrgConfig.nonprofitOrgRole,
    })
  }

  return isScreenLarge ? (
    <Button
      onClick={handleCreateChart}
      variant='primary'
      label='Add Chart'
      isDisabled={appState.ui.appPanel}
    />
  ) : null
}
